module.exports = __webpack_public_path__ + "static/media/S2N8-2.b61a45f0.svg";